<template>
  <tr class="v-table-key-value__row">
    <td class="v-table-key-value__key font-medium" :class="keyClass" :style="{ width: table.keyWidth }">
      <slot name="key">{{ rowKey }}</slot>
    </td>

    <td class="v-table-key-value__value" :class="valueClass" :data-key="rowKey" :style="{ width: table.valueWidth }">
      <slot>{{ value }}</slot>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { $tableKeyValueKey, injectRequired } from '../../utils/injections.ts'

interface Props {
  rowKey?: string | number
  value?: string | number
  keyClass?: any
  valueClass?: any
}

const table = injectRequired($tableKeyValueKey)

withDefaults(defineProps<Props>(), {
  rowKey: '',
  value: '',
  keyClass: undefined,
  valueClass: undefined,
})

defineSlots<{
  default?(): any
  key?(): any
}>()
</script>

<style>
.v-table-key-value__row {
  &:first-of-type > td {
    border-top: var(--border-light);
  }

  .v-table-key-value__key {
    vertical-align: top;
    padding: 15px 10px 15px 0;
  }

  > td {
    border-bottom: var(--border-light);
  }
}
</style>
